import { Component } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { IgxGridModule } from '@infragistics/igniteui-angular';

@Component({
  selector: 'app-amano-one-admin-multiple-facility-mapping',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatSelectModule,
    ReactiveFormsModule,
    FormsModule,
    MatOptionModule,
    MatButtonModule,
    IgxGridModule,
  ],
  templateUrl: './amano-one-admin-multiple-facility-mapping.component.html',
  styleUrl: './amano-one-admin-multiple-facility-mapping.component.scss',
})
export class AmanoOneAdminMultipleFacilityMappingComponent {
  selectedAccessGroup: string = '';

  facilities: { facilityId: string; facilityName: string }[] = [
    { facilityId: 'FAC-001', facilityName: 'North Lot' },
    { facilityId: 'FAC-002', facilityName: 'East Garage' },
    { facilityId: 'FAC-003', facilityName: 'South Deck' },
    { facilityId: 'FAC-004', facilityName: 'West Annex' },
    { facilityId: 'FAC-005', facilityName: 'Overflow Park' },
  ];
}
